import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { BasketAdvisorListDataItem } from '../../../BatchTicket/utils/types';
import { useBatchTicketRequestItem } from '../../hooks';

import { DesktopItemTable } from './desktop';
import { MobileItemTable } from './mobile';
import { TabletItemTable } from './tablet';

export interface ResponsiveItemCustomerProps extends ItemTableProps {
  detailsButtonIsDisabled: boolean;
  handlePressDetailsButton: () => void;
  detailsButtonColor: string;
}

export interface ItemTableProps {
  item: BasketAdvisorListDataItem;
}

export const ItemTable: React.FC<ItemTableProps> = ({ item }) => {
  const { detailsButtonIsDisabled, handlePressDetailsButton, detailsButtonColor } =
    useBatchTicketRequestItem({ item });

  const props = {
    item,
    detailsButtonIsDisabled,
    detailsButtonColor,
    handlePressDetailsButton,
  };

  const responsiveItemTable = useBreakpointValue({
    base: <MobileItemTable {...props} />,
    sm: <TabletItemTable {...props} />,
    lg: <DesktopItemTable {...props} />,
  });

  return responsiveItemTable;
};
